<h1 mat-dialog-title>Edit Project Details</h1>
<div mat-dialog-content [formGroup]="form">
    <mat-form-field appearance="fill" class="w-100 mb-3">
        <mat-label>Keywords (comma-separated)</mat-label>
        <input matInput formControlName="keywords" placeholder="e.g., 3d model, spreadsheet, engineering">
    </mat-form-field>

    <div class="w-100 mb-3">
        <mat-label>Description</mat-label>
        <angular-editor [config]="editorConfig" formControlName="description"></angular-editor>
        <mat-error *ngIf="form.controls['description'].hasError('required') && form.controls['description'].touched">
            Description is required.
        </mat-error>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!form.valid">Save</button>
</div>